<template>
  <div :ref="chartRefId" :style="{ width: '100%', height: '400px' }"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'CategoricalScatterChart',
  props: {
    dataInput: {
      type: Array,
      required: true
      // Example: [{ variable: 'Math', value: 85 }, { variable: 'Science', value: 92 }]
    }
  },
  data() {
    return {
      chartRefId: `scatter-chart-${this._uid}`,
      chartInstance: null
    };
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      const chartEl = this.$refs[this.chartRefId];
      if (!chartEl) return;

      this.chartInstance = echarts.init(chartEl);

      const categories = this.dataInput.map(d => d.variable);
      const values = this.dataInput.map(d => ({
        name: d.variable,
        value: [d.variable, Number(d.value)]
      }));

      const options = {
        title: {
          text: 'Categorical Scatter Plot'
        },
        tooltip: {
          trigger: 'item',
          formatter: ({ data }) => `${data.value[0]}: ${data.value[1]}`
        },
        xAxis: {
          type: 'category',
          data: categories,
          name: 'Variable'
        },
        yAxis: {
          type: 'value',
          name: 'Value'
        },
        series: [
          {
            type: 'scatter',
            symbolSize: 10,
            data: values,
            lineStyle: {
              color: '#FFD38A'
            },
            itemStyle: {
              color: '#D47900'
            }
          }
        ]
      };

      this.chartInstance.setOption(options);
      window.addEventListener('resize', this.resizeChart);
    },
    resizeChart() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
    getChartInstance() {
      return this.chartInstance;
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.resizeChart);
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  }
};
</script>
